import '../styles/Prev.css';
import '../styles/Grille.css';
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;

function Prev(gameMode) {
    const { t } = useTranslation();
	const [guessPrev, setGuessPrev] = useState([]);


    useEffect(() => {
        let url;
        switch (gameMode.gameMode) {
            case 'item':
                url = 'items-prev';
                break;
            case 'game':
                url = 'games-prev';
                break; 
            case 'character':
                url = 'characters-prev';
                break; 
            case 'sword':
                url = 'swords-prev';
                break; 
            default:
                url = 'items-prev';
        }
        console.log(url);
        console.log(`${URL_BACKEND}/api/${url}`);
        fetch(`${URL_BACKEND}/api/${url}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(guessPrev => { 
                console.log('Data fetched successfully:', guessPrev);
                setGuessPrev(guessPrev); 
            })
            .catch(error => { console.error('Error fetching data:', error); });
    }, [gameMode]);


	return (
		<div className="prev">
			<span className='span-gold'>{t('prev.yesterdaysGuess')} : </span>
                { 
                    gameMode.gameMode === 'item' ?
                        (<span className='span-white'>{guessPrev.nom_item}</span>)
                        
                    : gameMode.gameMode === 'game' ?           
                    (<span className='span-white'>{guessPrev.nom_jeu}</span>)

                    : gameMode.gameMode === 'character' ?           
                    (<span className='span-white'>{guessPrev.nom_personnage}</span>)

                    : gameMode.gameMode === 'sword' ?           
                    (<span className='span-white'>{guessPrev.nom_epee} ({guessPrev.acronyme_jeu})</span>)
                    
                    : null
                }
		</div>
	)
}

export default Prev
